import React from 'react';
import { format, parseISO } from 'date-fns';
import { DocFilter } from './constants';

export const buildWhereFromDocFilter = (
  where: any,
  value: string,
  fieldName: string,
  fieldDate: string,
) => {
  if (value === DocFilter.blank) {
    where = { ...where, $or: [{ [fieldName]: '' }, { [fieldName]: null }, { [fieldDate]: null }] };
  } else if (value === DocFilter.expired) {
    where = { ...where, [fieldDate]: { $lt: new Date() } };
  } else if (value === DocFilter.onemonth) {
    const oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
    where = {
      ...where,
      [fieldDate]: {
        $gte: new Date(),
        $lt: oneMonthFromNow,
      },
    };
  }
  return where;
};

